export enum MarketAdType {
    ALL = 0,
    RC = 1,
    OF = 2,
    PR = 3,
    VA = 4,
    AL = 5,
}